package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.at.oss.kotlin.manual.storage.common.contactinfo.ContactInfo
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
object ContactInfoValidator {
    val contactInfoSequencialValidate = fun(contactInfo: ContactInfo): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()

        // email
        validateEmail(contactInfo.email)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactInfo.email)?.also { errors.add(it) }
        // emailConfirmation
        validateEmailConfirmation(contactInfo.emailConfirmation, contactInfo.email)?.also { errors.add(it) }
        // telephone
        validateTelephone(contactInfo.telephone)?.also { errors.add(it) }

        return errors
    }

    // TODO Use a better validator (M1SS uses commons-validator:1.3.1)
    private val emailPattern = Regex("^(.+)@(.+)$")
    val validateEmail = fun(email: String): ValidationError? {
        return if (email.isNotBlank() && !emailPattern.matches(email)) ValidationError(code = CustomErrorCodes.EMAIL_INVALID.code)
        else null
    }

    val validateEmailConfirmation = fun(emailConfirmation: String?, email: String): ValidationError? {
        return if (emailConfirmation != null && emailConfirmation != email) ValidationError(code = CustomErrorCodes.EMAIL_CONFIRMATION_NOT_EQUAL.code)
        else null
    }

    private val telephonePattern = Regex("^(\\+)?([\\s\\-]?[0-9]+)+$")
    val validateTelephone = fun(telephone: String): ValidationError? {
        return if (telephone.isNotBlank() && !telephonePattern.matches(telephone)) ValidationError(code = CustomErrorCodes.TELEPHONE_INVALID.code)
        else null
    }
}
